import GenericModal from "../../components/GenericModal";
import { GroupIcon } from "./GroupIcon";
import StdButton from "../../components/StdButton";
import StdInput from "../../components/StdInput";
import MiniButton from "../../components/MiniButton";
import { colorsList } from "../../data/colorsList";
import { strLang } from "../../functions/strLang";
import { svgIcons } from "../../data/svgIcons";
import ClearIcon from "@mui/icons-material/Clear";
import MiniNumberCircle from "./MiniNumberCircle";

export default function SelectionBox({
  openModal,
  setOpenModal,
  selectionData,
  closeInput,
  search,
  setSearch,
  avatarsBox,
  avatarsData,
}) {
  return (
    <GenericModal open={openModal.status} data={selectionData}>
      <div
        style={{
          textAlign: "center",
          paddingBottom: 0,
          marginBottom: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 5,
            marginBottom: 10,
            justifyContent: "center",
          }}
        >
          {Object.keys(svgIcons).map((e, index) => (
            <div
              key={index}
              onClick={() => {
                setOpenModal({ status: true, group: Number(e) });
              }}
              style={{
                position: "relative",
                width: 100 / Object.keys(svgIcons).length + "%",
                height: 40,
              }}
            >
              <GroupIcon
                id={Number(e)}
                fill={
                  openModal.group === Number(e)
                    ? svgIcons[e].color
                    : colorsList.grey
                }
                style={{
                  height: "auto",
                  width: "100%",
                }}
              />
              <MiniNumberCircle
                total={avatarsData.filter((o) => o.MGROUP === Number(e)).length}
              />
            </div>
          ))}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: 5,
          }}
        >
          <StdButton
            label={strLang("createNew")}
            onClick={() => closeInput(true)}
          />
          <div style={{ flex: 1 }}>
            <StdInput
              placeholder={strLang("search")}
              value={search}
              change={(e) => setSearch(e.target.value)}
              style={{ padding: 0, width: "100%" }}
            />
          </div>
          <MiniButton
            Icon={ClearIcon}
            onClick={() => {
              setSearch("");
            }}
          />
        </div>
      </div>
      <div
        style={{
          flex: 1,
          height: 300,
          borderRadius: 10,
          textAlign: "center",
          overflowY: "auto",
          border: `solid 2px ${colorsList.darkGrey}`,
        }}
      >
        {avatarsBox()}
      </div>
    </GenericModal>
  );
}
